import React from 'react'
import { connect } from 'react-redux'
import InputElement from './InputElement'
import SelectElement from './SelectElement'
import TextAreaElement from './TextAreaElement'
import RadioElement from './RadioElement'
import CheckBoxElement from './CheckBoxElement'
import MessageElement from './MessageElement'
import ImageElement from './ImageElement'
import VideoElement from './VideoElement'

const components = {
  input: InputElement,
  select: SelectElement,
  textarea: TextAreaElement,
  radio: RadioElement,
  checkbox: CheckBoxElement,
  message: MessageElement,
  image: ImageElement,
  video: VideoElement,
}


class PageElement extends React.Component {


  render() {
    const { element, real_answer } = this.props
    const SpecificElement = components[element.question_type]
    return (
      <SpecificElement
        element={element}
        real_answer={real_answer}
      />
    )
  }
}

PageElement.propTypes = {
  element: React.PropTypes.shape({
    id: React.PropTypes.number,
    has_answer: React.PropTypes.bool,
    label: React.PropTypes.string,
    media_url: React.PropTypes.string,
    position: React.PropTypes.number,
    required: React.PropTypes.bool,
    page_element_options: React.PropTypes.arrayOf(React.PropTypes.shape({
      id: React.PropTypes.number,
      is_correct_answer: React.PropTypes.bool,
      option_value: React.PropTypes.string,
    })),
  }),
  real_answer: React.PropTypes.shape({}),
}


const mapStateToProps = state => ({
  ...state,
})

const mapDispatchToProps = () => ({
})


export default connect(mapStateToProps, mapDispatchToProps)(PageElement)



// WEBPACK FOOTER //
// ./src/components/MissionShow/MissionPage/FormPage/PageElement/index.jsx